import { render } from "./TemplateModal.vue?vue&type=template&id=22a0e535&scoped=true"
import script from "./TemplateModal.vue?vue&type=script&lang=js"
export * from "./TemplateModal.vue?vue&type=script&lang=js"

import "./TemplateModal.vue?vue&type=style&index=0&id=22a0e535&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a0e535"]])

export default __exports__